import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppConfig } from '../../AppConfig';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import Button from '@material-ui/core/Button';
import StepConnector from '@material-ui/core/StepConnector';
import clsx from 'clsx';
import StepLabel from '@material-ui/core/StepLabel';
import Icon from '@material-ui/core/Icon';

function StepIconComponent(props) {
  const { active, completed } = props;
  return (
    <div
      className={clsx(css(Styles.StepIconRoot), {
        [css(Styles.StepIconActive)]: active,
      })}
    >
      {completed ?
        <Icon className={css(Styles.iconContainer)}>done</Icon>
        :
        <div
          className= {clsx(css(Styles.stepIconcircle), {
            [css(Styles.stepIconcircleActive)]: active,
          })}
        />}
    </div>
  );
}

export class StepperComponent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { activeStep } = this.props;

    return(
      <div className={css(Styles.stepperContainer)}>
        {this.props.data.length > 1 &&
        <Stepper
          alternativeLabel
          activeStep={activeStep}
          connector={
            <StepConnector
              classes={{
                alternativeLabel: css(Styles.stepAlternativeLabel),
                lineHorizontal: css(Styles.stepLineHorizontal)
              }}
            />
          }
          className={css(Styles.stepper)}
        >
          {this.props.data.map((item,index) => {
            return (
              <Step key={item.id} >
                <StepLabel
                  StepIconComponent={StepIconComponent}
                  onClick={this.props.handleStep(index,item.key)}
                  completed={item.complete}
                  classes={{
                    label: css(Styles.stepLabel),
                    active: css(Styles.stepLabelActive),
                  }}
                  className={css(Styles.step)}
                >
                  {item.title}
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
        }
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  stepperContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '@media (max-width: 1024px)': {
      margin: '15px 0px',
      alignSelf: 'normal',
    }
  },
  stepper: {
    backgroundColor: AppTheme.primaryBg,
    padding: 0,
    flex: 1,
  },
  stepAlternativeLabel: {
    top: 15,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
    '@media (max-width: 767px)': {
      top: 12,
      left: 'calc(-50% + 13px)',
      right: 'calc(50% + 13px)',
    }
  },
  stepLineHorizontal: {
    border: '2px solid' + AppTheme.primaryColor
  },
  step: {
    ':hover' : {
      cursor: 'pointer'
    }
  },
  stepLabel: {
    color: AppTheme.textColor,
    fontSize: AppTheme.subTitleSize - 4,
    marginTop: 10,
    fontWeight: 'normal',
    '@media (max-width: 767px)': {
      fontSize: 10,
    }
  },
  stepLabelActive: {
    color: AppTheme.tertiaryColor,
    fontSize: AppTheme.subTitleSize - 4,
    marginTop: 10,
    fontWeight: 'normal',
    '@media (max-width: 767px)': {
      fontSize: 10,
    }
  },
  StepIconRoot: {
    backgroundColor: AppTheme.tertiaryBg,
    borderRadius: '50%',
    border:' 3px solid' + AppTheme.primaryColor,
    width: 27,
    height: 27,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      width: 20,
      height: 20,
    }
  },
  StepIconActive: {
    border:' 3px solid' + AppTheme.tertiaryColor,
  },
  iconContainer: {
    color: AppTheme.selectedColor,
    fontSize: 37,
    zIndex: 1,
    fontWeight: 'bold',
    width: 33,
    height: 41,
    '@media (max-width: 767px)': {
      fontSize: 24,
      width: 22,
      height: 26,
    }
  },
  stepIconcircle: {
    borderRadius: '50%',
    backgroundColor: AppTheme.tertiaryBg,
    width: 21,
    height: 21,
    '@media (max-width: 767px)': {
      width: 16,
      height: 16,
    }
  },
  stepIconcircleActive: {
    borderRadius: '50%',
    backgroundColor: AppTheme.secondaryColor,
    width: 21,
    height: 21,
    '@media (max-width: 767px)': {
      width: 16,
      height: 16,
    }
  },
})


// WEBPACK FOOTER //
// ./src/components/quizzing/StepperComponent.js